import React from 'react';
import kws from '../images/clients/kws.png';
import geps from '../images/clients/geps.png';
import protergia from '../images/clients/protergia.png';
import img from "../images/company2.jpg";
import map1 from "../images/map1.jpg";
import map2 from "../images/map2.jpg";
import {Link} from "react-router-dom";

const clientImage = {
    height: '10rem',
    width: 'auto',
    mixBlendMode: 'colorBurn'
}

const Contacts = () => {
    return (
        <div id="contacts" className="bg-brand-50 py-12">
            <section data-aos="fade-up">
                <div className="my-4 py-4">
                    <h2 className="my-2 text-center text-3xl text-brand uppercase font-bold">Kontakt</h2>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-brand'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-black">

                    </h2>
                </div>

                <div className="m-auto max-w-6xl">
                    <div
                        className="flex flex-col lg:flex-row py-1 justify-between lg:text-left"
                        data-aos="fade-up"
                    >
                        <div
                            className="lg:w-1/2 flex text-center flex-col lg:text-left  lg:mx-4 justify-center  lg:border-r-brand-100 lg:border-r-[1px] ">
                            <h3 className="text-3xl  text-brand font-bold">Sídlo spoločnosti</h3>
                            <div
                                className="grid justify-items-center pt-8 text-xl lg:grid-cols-2 lg:justify-items-start lg:pr-10">
                                <div className="mb-4 lg:mr-9">
                                    <p><b>M&rivet, s.r.o.</b></p>
                                    <p>Závodská 4</p>
                                    <p>010 01 Žilina</p>

                                    <div className="pt-3">
                                        <p>IČO: 36300845</p>
                                        <p>DIČ: 2020111500</p>
                                    </div>
                                </div>
                                <a href="https://maps.app.goo.gl/ntEwTKizagpUDm9d9" target="_blank">
                                    <img src={map1} className="rounded-lg w-max"/>
                                </a>


                            </div>
                        </div>
                        <div
                            className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
                            data-aos="zoom-in"
                            data-aos-delay="500"
                        >
                            <h3 className="text-3xl  text-brand font-bold">Prevádzka - rezanie vodným lúčom</h3>
                            <div
                                className="grid justify-items-center pt-8 text-xl lg:grid-cols-2 lg:justify-items-start">
                                <div className="mb-4 lg:mr-9">
                                    <p><b>M&rivet, s.r.o.</b></p>
                                    <p className={'text-sm'}>(hala za Kultúrnym domom)</p>
                                    <p>Kysucký Lieskovec 30</p>
                                    <p>023 34</p>
                                </div>
                                <a href="https://maps.app.goo.gl/a7PEa7jons7azbFs6" target="_blank">
                                    <img src={map2} className="rounded-lg w-max"/>
                                </a>


                            </div>
                        </div>
                    </div>
                </div>
                <div className="m-auto max-w-6xl mt-5 pt-5 border-t-[1px] border-t-brand-100"
                     data-aos="zoom-in"
                     data-aos-delay="500">
                    <h3 className="m-auto text-3xl  max-w-max text-brand font-bold">Kontaktné osoby</h3>
                    <div
                        className="flex flex-col align-items-center text-center justify-around mt-8 sm:flex-row sm:text-left ">
                        <div className="my-3 text-xl text-black">
                            <h4 className="text-brand mb-2  font-semibold">Konateľ spolocnosti</h4>
                            <p className="font-semibold">Ing. Július Mičieta</p>
                            <p>tel. 0905 711 496</p>
                            <p><a href="mailto:mrivetjm@gmail.com"
                                  className="underline">mrivetjm@gmail.com</a></p>
                        </div>
                        <div className="my-3 text-xl text-black">
                            <h4 className="text-brand mb-2  font-semibold">Obchodný zástupca</h4>
                            <p className="font-semibold">Pavol Slocík</p>
                            <p>tel. 0903 587 415</p>
                            <p><a href="mailto:pavol.slocik@mrivet.sk"
                                  className="underline">pavol.slocik@mrivet.sk</a></p>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Contacts;